'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider
    .state('login', {
      url: '/login',
      template: require('./login/login.html'),
      controller: 'LoginController',
      controllerAs: 'vm'
    })
    .state('logout', {
      url: '/logout?referrer',
      referrer: 'main',
      template: '',
      controller($state, Auth) {
        'ngInject';

        //var referrer = $state.params.referrer || $state.current.referrer || 'main';
        Auth.logout();
        //$state.go(referrer);
        window.location.href = '/';
      }
    })
    .state('recoverRequest', {
      url: '/recover/request',
      template: require('./recover/recoverRequest.html'),
      controller: 'RecoverRequestController',
      controllerAs: 'vm'
    })
    .state('recoverPassword', {
      url: '/recover/password/:token',
      template: require('./recover/recoverPassword.html'),
      controller: 'RecoverPasswordController',
      controllerAs: 'vm'
    })
    .state('settings', {
      url: '/settings',
      template: require('./settings/settings.html'),
      controller: 'SettingsController',
      controllerAs: 'vm',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js